var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DateTimeRangeInput"},[_c('el-date-picker',{style:(_vm.pickerStyle),attrs:{"value":_vm.dateRange,"type":"daterange","picker-options":_vm.pickerOptions,"range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right"},on:{"input":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }